var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"title":_vm.$t('dashboard')}},[_c('h1',{staticClass:"greeting"},[_c('span',{staticClass:"today"},[_vm._v(" "+_vm._s(_vm.$t("today_is"))+" "+_vm._s(_vm.todayWeekday)+", "+_vm._s(_vm.todayFull))])]),_c('div',{staticClass:"clock-widget"})])
}
var staticRenderFns = []

export { render, staticRenderFns }